

import React from "react"
import { View, Text, TouchableOpacity } from "react-native"

export const Rating = ({ startingValue = 0, imageSize = 20, onFinishRating, readonly = false, ...props }: any) => {
  const [rating, setRating] = React.useState(startingValue)

  const handlePress = (value: number) => {
    if (!readonly) {
      setRating(value)
      if (onFinishRating) {
        onFinishRating(value)
      }
    }
  }

  return (
    <View style={{ flexDirection: "row" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <TouchableOpacity key={star} onPress={() => handlePress(star)} disabled={readonly}>
          <Text style={{ fontSize: imageSize, color: star <= rating ? "#FFD700" : "#CCC" }}>★</Text>
        </TouchableOpacity>
      ))}
    </View>
  )
}

export const AirbnbRating = Rating

export default Rating
